<app-page-header-bar page-title="Interactions" [loading]="isLoadingInteractions()">
	<a routerLink="/relationships" mat-button>Relationships</a>

	<app-responsive-content second-row-content>
		<button (click)="addInteraction()" class="primary" mat-flat-button responsive-element="pinned">
			<mat-icon>add</mat-icon>
			<span>Add Interaction</span>
		</button>
		
		<app-group-by-menu responsive-element="menu"
			[group-by]="groupBy()"
			[options]="groupByOptions"
			(grouping-selected)="groupBy.set($event)"
		/>

		<app-expand-collapse-menu responsive-element="menu"
			[show-expand]="showExpandAllGroupsButton()"
			[show-collapse]="showCollapseAllGroupsButton()"
			(expand-all)="collapseOrExpandAllGroups(true)"
			(collapse-all)="collapseOrExpandAllGroups(false)"
		/>
	</app-responsive-content>
</app-page-header-bar>

<p>
	Add interactions through the buttons at the top of this page.<br />
	{{TOPIC_HINT_VERBIAGE}}
</p>

<div class="page-content">
	<div class="main-content">
		@if (isLoadingInteractions()) {
			<mat-spinner diameter="75" />
		}
		@else {
			@for (group of groupedInteractions(); track group.timeUnitsAgo) {
				@defer (hydrate on viewport) {
					<app-card-group
						group-of="interactions"
						[header]="group.timeAgoText"
						[card-count]="group.interactions.length"
						header-color="var(--color-accent)"
						[is-card-in-group-highlighted]="group.timeAgoText === highlightedCard().groupKey"
					>
						@for (interaction of group.interactions; track interaction._id; let index = $index) {
							<app-card class="small-viewport-only"
								[interaction]="interaction"
								collapsible
								always-show-interaction-owner
								always-show-left-text
								(edit-interaction)="editInteraction($event)"
								(delete-interaction)="deleteInteraction($event)"
								(relationship-name-click)="editRelationship($event)"
								[scroll-to-and-highlight]="group.timeAgoText === highlightedCard().groupKey && index === highlightedCard().indexInGroup"
							>
								<app-interaction-card-content [interaction]="interaction" />
							</app-card>
							<app-row class="large-viewport-only"
								[interaction]="interaction"
								[scroll-to-and-highlight]="group.timeAgoText === highlightedCard().groupKey && index === highlightedCard().indexInGroup"
								(edit-interaction)="editInteraction($event)"
								(delete-interaction)="deleteInteraction($event)"
								(relationship-name-click)="editRelationship($event)"
							/>
						}
					</app-card-group>
				}
			}
		}
	</div>

	<app-side-panel class="large-viewport-only" aria-live="polite">
		@if (topicsService.selectedTopic(); as topic) {
			<h3>{{topic.name}}</h3>
			<p [innerHTML]="topic.notes | newlinesToBr"></p>
		} @else {
			<p class="panel-placeholder">Select a topic to view notes</p>
		}
	</app-side-panel>
</div>
